import { useEffect, useState } from "react";
import {
  getFontScale,
  setFontScale as setFontScaleStorage,
  type FontScale,
} from "./theme";

interface UseFontScaleReturn {
  scale: FontScale;
  setScale: (next: FontScale) => void;
}

export function useFontScale(): UseFontScaleReturn {
  const [scale, setScaleState] = useState<FontScale>(() => getFontScale());

  const setScale = (next: FontScale): void => {
    setFontScaleStorage(next);
    setScaleState(next);
  };

  // Sync entre tabs.
  useEffect(() => {
    const onStorage = (e: StorageEvent): void => {
      if (e.key !== "innovasuite.fontScale") return;
      const v = e.newValue;
      if (v === "100" || v === "112" || v === "125") {
        setFontScaleStorage(v);
        setScaleState(v);
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  return { scale, setScale };
}
